import { ParsedUrlQueryInput } from 'querystring';

import { config } from 'config/config';
import { SingletonRouter } from 'next/router';

const { BASE_URL } = config.APP;

interface Props {
  destination: any;
  ctx?: any;
  router?: SingletonRouter;
  query?: ParsedUrlQueryInput;
}

export default function redirectTo(
  destination,
  { res, status }: any = {},
  router?: SingletonRouter,
  query?: ParsedUrlQueryInput | string,
) {
  const newLocation = BASE_URL + destination;
  if (res) {
    res.writeHead(status || 302, {
      Location: newLocation,
    });
    res.end();
  } else {
    if (destination[0] === '/' && destination[1] !== '/') {
      router &&
        router.push(
          { pathname: destination, query },
          { pathname: newLocation, query },
          {
            shallow: true,
          },
        );
    } else {
      window.location.replace(`${newLocation}?${query}`);
    }
  }
}
